import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { detectLanguage } from './getLanguageFromUrl';
import { SUPPORTED_LOCALES } from "./locales";


let initialized = false;

export async function initI18n() {
    if (initialized) return i18n; // protection contre double init

    const lng = await detectLanguage();
    const filesTransaltions = ['preferenceCenter', 'translation', 'header', 'footer', 'payment', 'notFound', 'rgpd', 'shipping']
    await i18n
        .use(HttpBackend)
        .use(initReactI18next)
        .init({
            lng,
            fallbackLng: 'fr-FR',
            supportedLngs: SUPPORTED_LOCALES,
            load: 'currentOnly',
            ns: [...filesTransaltions],
            defaultNS: 'translation',
            debug: process.env.NODE_ENV === 'development',
            interpolation: { escapeValue: false },
            backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
        });

    initialized = true;
    return i18n;
}

export default i18n;
